var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import axios from 'axios';
import Bowser from 'bowser';
import { format, parse } from 'date-fns';
var trackEvent = function (event_1) {
    var args_1 = [];
    for (var _b = 1; _b < arguments.length; _b++) {
        args_1[_b - 1] = arguments[_b];
    }
    return __awaiter(void 0, __spreadArray([event_1], args_1, true), void 0, function (event, properties, andThen) {
        var browser, loginMethod;
        if (properties === void 0) { properties = {}; }
        if (andThen === void 0) { andThen = null; }
        return __generator(this, function (_d) {
            browser = Bowser.getParser(window.navigator.userAgent);
            loginMethod = getLoginMethod();
            axios
                .post(route('api.event'), __assign({ event: event, browser: browser.getBrowser(), login_method: loginMethod, res: {
                    // https://stackoverflow.com/a/1038781/16645 for why
                    width: Math.max(document.body.scrollWidth, document.documentElement.scrollWidth, document.body.offsetWidth, document.documentElement.offsetWidth, document.documentElement.clientWidth),
                    height: Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.documentElement.clientHeight),
                } }, properties))
                .then(function (response) {
                // Just here for debugging that might need to happen
                return response;
            })
                .finally(function () {
                if (typeof andThen !== 'function')
                    return;
                andThen();
            });
            return [2 /*return*/];
        });
    });
};
/**
 * Determines the login method (Desktop, Mobile, or Unknown) based on the user agent.
 */
var getLoginMethod = function () {
    var browser = Bowser.getParser(window.navigator.userAgent);
    var platform = browser.getPlatform();
    if (platform && platform.type) {
        if (platform.type === 'desktop') {
            return 'Desktop';
        }
        else if (platform.type === 'tablet' || platform.type === 'mobile') {
            return 'Mobile';
        }
        // Fallback for other types Bowser might return, or if it's explicitly something else
        return platform.type;
    }
    return 'Unknown';
};
var formatDate = function (dateString) {
    if (!dateString) {
        return '';
    }
    for (var _b = 0, _d = ['MM/dd/yyyy', 'MM-dd-yyyy']; _b < _d.length; _b++) {
        var dtFormat = _d[_b];
        try {
            var parsed = parse(dateString, dtFormat, new Date());
            if (parsed instanceof Date) {
                return format(parsed, 'MM/dd/yyyy');
            }
        }
        catch (error) { }
    }
    throw new Error('No matching dtFormat for ' + dateString);
};
export { trackEvent, formatDate };
